// From the pure schema entry of platform: this file is bundled into the web app through ./schema.
import { definePermissions } from '@mkcore/platform/schema';

/** Permissions of the knowledge layer (D29, U7). Spaces of a client or project add the object scope on top. */
export const knowledgePermissions = definePermissions('knowledge', {
  read: 'Read and search knowledge in the spaces you may see',
  create: 'Write knowledge items, memories and captures',
  update: 'Change, move, archive and restore knowledge items',
  delete: 'Forget knowledge: delete items and documents with what was derived from them',
  manage: 'Manage spaces, their members, sources and the index',
  approve: 'Approve changes to knowledge that agents propose',
});
